import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useTranslate } from "src/locales";

interface PediatricAssessmentFooterProps {
    sx?: any;
}

export default function PediatricAssessmentFooter(props: Readonly<PediatricAssessmentFooterProps>) {
    const { sx } = props;
    const { t } = useTranslate();

    const scoringData = [
        {
            score: t("pediatric-assessment.scoring-table.score-0"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.eval-every-shift"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.routine-monitoring"),
            action: ""
        },
        {
            score: t("pediatric-assessment.scoring-table.score-1"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.eval-every-4h"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.nurse-shift-nurse"),
            action: t("pediatric-assessment.scoring-table.decision-no-escalation")
        },
        {
            score: t("pediatric-assessment.scoring-table.score-2"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.eval-every-2-4h"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.nurse-shift-floor-doctor"),
            action: t("pediatric-assessment.scoring-table.decision-no-escalation")
        },
        {
            score: t("pediatric-assessment.scoring-table.score-3"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.eval-every-1h"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.nurse-shift-superviser-floor-doctor-oncall"),
            action: t("pediatric-assessment.scoring-table.inform-primary-doctor")
        },
        {
            score: t("pediatric-assessment.scoring-table.score-4-5"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.eval-every-30m"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.nurse-shift-superviser-floor-doctor-oncall"),
            action: t("pediatric-assessment.scoring-table.inform-primary-doctor")
        },
        {
            score: t("pediatric-assessment.scoring-table.score-6"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.continuous-monitoring"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.personnel-score-6"),
            action: t("pediatric-assessment.scoring-table.action-score-6")
        },
        {
            score: t("pediatric-assessment.scoring-table.score-7"),
            evaluationFrequency: t("pediatric-assessment.scoring-table.continuous-monitoring"),
            responsiblePersonnel: t("pediatric-assessment.scoring-table.nurse-shift-nurse"),
            action: t("pediatric-assessment.scoring-table.action-score-7")
        }
    ];

    return (
        <Box sx={{ mt: 3, ...sx }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                {t("pediatric-assessment.scoring-table.title")}
            </Typography>

            <TableContainer component={Paper} elevation={2}>
                <Table
                    size="small"
                    aria-label="pediatric assessment scoring table"
                    sx={{
                        border: "1px solid #ddd",
                        borderCollapse: "collapse",
                        "& .MuiTableCell-root": {
                            border: "1px solid #ddd"
                        }
                    }}
                >
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell sx={{ fontWeight: "bold", width: 120 }}>{t("pediatric-assessment.scoring-table.score")}</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>{t("pediatric-assessment.scoring-table.evaluation-frequency")}</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>{t("pediatric-assessment.scoring-table.responsible-personnel")}</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>{t("pediatric-assessment.scoring-table.action")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {scoringData.map((row, index) => (
                            <TableRow
                                key={row.score}
                                sx={{
                                    "&:hover": { backgroundColor: "#f9f9f9" }
                                }}
                            >
                                <TableCell sx={{ fontWeight: "bold" }}>
                                    {row.score}
                                </TableCell>
                                <TableCell>
                                    {row.evaluationFrequency}
                                </TableCell>
                                <TableCell>
                                    {row.responsiblePersonnel}
                                </TableCell>
                                <TableCell sx={{ fontSize: "0.875rem" }}>
                                    {row.action}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
